import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VerticalLabelPipe } from '@callrail/looky/vertical-label';
import {
  DirectivesModule as UiDirectivesModule,
  PipesModule,
  SelectModule,
  TimeAgoModule,
} from '@callrail/looky/ui';

import { DirectivesModule as CoreDirectivesModule } from '../../directives/directives.module';
import { AppNoticeMessageComponent } from './app-notice-message/app-notice-message.component';
import { AppNoticesComponent } from './app-notices/app-notices.component';
import { PersistentAppNoticeComponent } from './persistent-app-notice/persistent-app-notice.component';

@NgModule({
  declarations: [AppNoticesComponent, PersistentAppNoticeComponent],
  exports: [
    AppNoticesComponent,
    PersistentAppNoticeComponent,
    AppNoticeMessageComponent,
  ],
  imports: [
    AppNoticeMessageComponent,
    CommonModule,
    SelectModule,
    CoreDirectivesModule,
    UiDirectivesModule,
    RouterModule,
    PipesModule,
    TimeAgoModule,
    VerticalLabelPipe,
  ],
})
export class AppNoticesModule {}
